import { render, staticRenderFns } from "./KarsilastirmaDataTableAy.vue?vue&type=template&id=0f689bdb&scoped=true"
import script from "./KarsilastirmaDataTableAy.vue?vue&type=script&lang=ts"
export * from "./KarsilastirmaDataTableAy.vue?vue&type=script&lang=ts"
import style0 from "./KarsilastirmaDataTableAy.vue?vue&type=style&index=0&id=0f689bdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f689bdb",
  null
  
)

export default component.exports